import React from 'react';

// Bu bileşen, sayısal değerleri "Para Birimi" formatında gösteren bir input oluşturur.
// Örn: Kullanıcı 38000 yazar, ekranda 38.000,00 ₺ görünür.
// Ancak arka planda (onChange) saf sayı (38000) döner.

const CurrencyInput = ({ value, onChange, placeholder, disabled, className, style }) => {

  // Sayıyı formatla: 1234.56 -> "1.234,56 ₺"
  const formatDisplayValue = (val) => {
    if (val === '' || val === null || val === undefined) return '';
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 2,
    }).format(val);
  };

  // Kullanıcı yazarken çalışır
  const handleChange = (e) => {
    // Sadece rakamları al (nokta ve virgülü temizle)
    const rawValue = e.target.value.replace(/[^0-9]/g, '');

    if (rawValue === '') {
      onChange(''); // Boşsa boş dön
      return;
    }

    // Kuruş hesabı için 100'e böl (Son 2 hane kuruş kabul edilir)
    const numberValue = parseInt(rawValue, 10) / 100;

    // Üst componente saf sayıyı gönder
    onChange(numberValue);
  };

  return (
    <input
      type="text"
      value={formatDisplayValue(value)} // Ekranda formatlı göster
      onChange={handleChange}           // Değişince işle
      placeholder={placeholder}
      disabled={disabled}
      className={className}
      style={style}
    />
  );
};

export default CurrencyInput;